import React, { useEffect, useState } from "react";
import DiaglogBox from "../../atoms/DiaglogBox";
import Button from "../../atoms/Button";
import Input from "../../atoms/Input";
import { requestPopup } from "../../../utils/API/requestPopup";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import { getKycRegistries } from "../../../utils/API/getKycRegistries";

const RequestDialog = ({
  open,
  onOk,
  onCancel,
  selectedRowData,
  selectedColumns,
}) => {
  const dispatch = useDispatch();
  const [creditsToTransfer, setCreditsToTransfer] = useState(0);
  const [registries, setRegistries] = useState([]);
  const [selectedRegistry, setSelectedRegistry] = useState("");
  const [choosenRegistry, setChoosenRegistry] = useState("");
  const [error, setError] = useState({});

  useEffect(() => {
    if (open) {
      fetchKycRegistries();
    }
  }, [open]);

  const fetchKycRegistries = async () => {
    try {
      const response = await getKycRegistries(dispatch);
      const registryOptions = [];

      if (response.data) {
        if (
          response.data.organization &&
          response.data.organization.orgInfo &&
          response.data.organization.orgInfo.registry_details
        ) {
          response.data.organization.orgInfo.registry_details.forEach(
            (registry) => {
              registryOptions.push({
                value: registry.registry_id,
                name: registry.registry_name,
              });
            }
          );
        }

        if (
          response.data.individual &&
          response.data.individual.basicInfo &&
          response.data.individual.basicInfo.registry_details
        ) {
          response.data.individual.basicInfo.registry_details.forEach(
            (registry) => {
              registryOptions.push({
                value: registry.registry_id,
                name: registry.registry_name,
              });
            }
          );
        }
      }

      setRegistries(registryOptions);
    } catch (error) {
      toast.error(error.message || "Failed to fetch registries");
    }
  };

  const handleCreditsChange = (event) => {
    const enteredCredits = parseInt(event.target.value, 10);
    const maxCredits = selectedRowData ? selectedRowData["No. of Credits"] : 0;
    setCreditsToTransfer(Math.min(enteredCredits, maxCredits));
    setError((prev) => ({ ...prev, numberOfCreditsError: "" })); // Clear error
  };

  const handleRegistryChange = (event) => {
    setSelectedRegistry(event.target.value);
    const selectedRegistryId = event.target.value;
    const selectedRegistry =
      registries.find((registry) => registry.value === selectedRegistryId)
        ?.name || "";
    setChoosenRegistry(selectedRegistry);
    setError((prev) => ({ ...prev, choosenRegistryError: "" })); // Clear error
  };

  const handleRequestTransferOk = async () => {
    const project_id = selectedRowData["Project"];
    const numberOfTransferedCredits = creditsToTransfer;

    const transferFormData = {
      project: project_id,
      no_of_credits: numberOfTransferedCredits,
      registry_name: choosenRegistry,
    };

    // Error handling logic
    let isValid = true;
    if (choosenRegistry === "") {
      setError((prev) => ({
        ...prev,
        choosenRegistryError: "Please select a registry",
      }));
      isValid = false;
    }
    if (numberOfTransferedCredits === 0) {
      setError((prev) => ({
        ...prev,
        numberOfCreditsError: "Please enter the number of credits",
      }));
      isValid = false;
    }

    if (!isValid) return;

    try {
      await requestPopup(transferFormData, dispatch);
      // console.log("Transformed Data:", transferFormData);
      setCreditsToTransfer(0);
      setSelectedRegistry("");
      onCancel();
      onOk();
    } catch (error) {
      console.log(error);
      toast.error("Request already created");
    }
  };

  const handleCancel = () => {
    setCreditsToTransfer(0);
    setSelectedRegistry("");
    setError({});
    onCancel();
  };

  return (
    <DiaglogBox
      width={430}
      onCancel={handleCancel}
      open={open}
      closeIcon={false}
    >
      <div className="py-2">
        {selectedColumns && selectedRowData && (
          <div>
            <div className="flex justify-between text-center py-3">
              {selectedColumns.map((column) => (
                <div key={column} className="text-sm font-bold mx-8">
                  {column}
                </div>
              ))}
            </div>
            <hr />
            <div className="flex justify-between mt-2 text-center ">
              {selectedColumns.map((column) => (
                <div key={column} className="text-sm font-medium mx-6">
                  {column === "Registry" ? (
                    <div className="w-24">
                      <select
                        value={selectedRegistry}
                        onChange={handleRegistryChange}
                        className="w-full h-8 border-b-1 border-gray-300 text-gray-400 outline-none bg-transparent"
                      >
                        <option value="">Select</option>
                        {registries.map((registry) => (
                          <option key={registry.value} value={registry.value}>
                            {registry.name}
                          </option>
                        ))}
                      </select>
                      {error.choosenRegistryError && (
                        <div className="text-red-500 text-xs font-noraml text-start">
                          {error.choosenRegistryError}
                        </div>
                      )}
                    </div>
                  ) : (
                    selectedRowData[column]
                  )}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
      <div className="text-[15px] font-medium ml-6 pt-4">
        Total Credit - {selectedRowData ? selectedRowData["No. of Credits"] : 0}
      </div>
      <div className="flex ml-6">
        <div className="self-end text-sm font-bold mr-4">
          No. of Credits to Transfer
        </div>
        <div>
          <Input
            variant="secondary"
            type="number"
            className={"w-[111px]"}
            value={creditsToTransfer}
            onChange={handleCreditsChange}
          />
          {error.numberOfCreditsError && (
            <div className="text-red-500 text-xs font-noraml text-start">
              {error.numberOfCreditsError}
            </div>
          )}
        </div>
      </div>
      <div className="mx-[84px] flex justify-between py-6">
        <Button
          color={"blue"}
          className={"w-[120px] h-[40px] text-white text-sm font-bold"}
          variant={"primary"}
          onClick={handleRequestTransferOk}
        >
          Transfer
        </Button>

        <Button
          borderColor={"blue"}
          className={"w-[120px] h-[40px] text-blue-800 text-sm font-bold"}
          variant={"primary"}
          onClick={handleCancel}
        >
          Cancel
        </Button>
      </div>
    </DiaglogBox>
  );
};

export default RequestDialog;
